// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1pm78","title":"Info_title__2YE9y","selects":"Info_selects__25mNo","requiredAsterisk":"Info_requiredAsterisk__Xe0Qj"};